import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import MenuBotones from "../../MenuBotones";

function BotonesComprasDirectas() {
  const { user } = useContext(AuthContext);

  const secciones = [
    { section: "", items: [
      { label: "Ordenes de Compra Directa", icon: "fas fa-shopping-basket", color: "#2563eb", href: "/ListadoOrdenesCompraDirectas", enabled: !!(user.menu_compras && user.menu_oc) },
      { label: "Recepción Directa", icon: "fas fa-cart-plus", color: "#2563eb", href: "/ListadoComprasDirectas", enabled: !!(user.menu_compras) },
    ]},
  ];

  return (
    <MenuBotones
      titulo="Compras Directas"
      descripcion="Órdenes y recepción directa"
      icono="fas fa-cart-plus"
      color="#2563eb"
      secciones={secciones}
    />
  );
}

export default BotonesComprasDirectas;
